
<b-sidebar
  v-model="isExpanded"
  right
  shadow
  no-header
  no-close-on-esc
  no-close-on-backdrop
  width="420px"
  class="saved-search-sidebar smallerfont"
  @shown="onSidebarOpened"
>
  <!-- Header -->
  <div class="d-flex align-items-center px-3 py-2 border-bottom bg-light">
    <button type="button" class="btn btn-light" @click="$emit('close')">
        <i class="bi bi-x"></i>
    </button>
    <h6 class="mb-0 font-weight-bold">Save {{ $route.meta.tabText }} Template</h6>
  </div>

  <div class="p-3 text-left">
    <b-modal   
      v-model="existingSavedSearchExistModal" 
      title="Saved template already exists"
    >
      <p class="mb-0">Do you want to replace it?</p>
      <template #modal-footer>
        <b-button variant="secondary" @click="existingSavedSearchExistModal = false">No</b-button>
        <b-button variant="primary" @click="updateSavedSearch()">Yes</b-button>
      </template>
    </b-modal>
    <b-form @submit.stop.prevent="saveNew">
      <b-form-group
        label-for="ss-name"
        label-size="sm"
        label-class="mb-1"
      >
        <b-form-input
          id="ss-name"
          v-model.trim="draft.name"
          required
          autofocus
          placeholder="Title, e.g. Prime-time fridays"
          class="smallerfont"
          ref="nameInput"
        />
      </b-form-group>

      <b-form-group
        label-for="ss-desc"
        label-size="sm"
        label-class="mb-1"
      >
        <b-form-textarea
          id="ss-desc"
          v-model.trim="draft.description"
          rows="2"
          max-rows="6"
          :maxlength="200"
          placeholder="Description (optional)"
          class="smallerfont"
          ref="descriptionInput"
        />
        <small class="text-muted"
          >{{ (draft.description || "").length }}/200</small
        >
      </b-form-group>

      <b-button variant="primary" class="smallerfont" @click="saveNew">
        <i class="bi bi-save mr-1" aria-hidden="true"></i> Save
    </b-button>
    </b-form>

    <hr class="my-3" />

    <!-- LIST (scrollable) -->
    <small class="text-muted d-block mb-2">Your saved templates</small>

    <b-alert v-if="!savedSearches.length" show variant="info"
      >Nothing saved yet. Create your first template above.</b-alert
    >

    <div v-else class="saved-list overflow-auto mb-3">
      <b-list-group>
        <b-list-group-item
          v-for="savedSearch in savedSearches"
          :key="savedSearch.value"
          button
          @click="select(savedSearch)"
          :class="{ 'active-item': selected && selected.value === savedSearch.value }"
        >
          <div class="text-truncate pr-2">
            <div class="font-weight-bold text-truncate">{{ savedSearch.text }}</div>
            <div class="small text-muted">{{ fmtShort(savedSearch.date) }}</div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>

    <!-- DETAILS & ACTIONS -->
    <div v-if="selected" class="mt-2">
      <small class="text-muted d-block mb-1">Details & actions</small>
      <b-card no-body class="mb-2">
        <b-card-body class="details-body">
          <div class="details-content">
            <div class="mb-1">
              <!-- Full title, no truncation -->
              <h6 class="mb-1 smallerfont" :title="selected.text">{{ selected.text }}</h6>
              <span class="small text-muted">{{
                fmt(selected.date)
              }}</span>
            </div>
            <p class="mb-0 text-muted white-space">
              {{ selected.description || "—" }}
            </p>
          </div>

          <div class="d-flex mt-3 btn-row">
            <b-button
              variant="danger"
              class="flex-fill mr-2 smallerfont"
              @click="askDelete(selected)"
            >
              <b-icon-trash class="mr-1" />Delete
            </b-button>
            <b-button
              variant="secondary"
              class="applybtn smallerfont"
              @click="applySelected"
            >
              <b-icon-check class="applyicon" />Apply
            </b-button>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>

  <b-modal id="del" v-model="delDlg" title="Delete saved template?" centered>
    <p class="mb-0">
      Delete “{{ toDelete && toDelete.text }}”? This cannot be undone.
    </p>
    <template #modal-footer>
      <b-button variant="link" @click="delDlg = false">Cancel</b-button>
      <b-button variant="danger" @click="confirmDelete">Delete</b-button>
    </template>
  </b-modal>
</b-sidebar>
